import { useMemo, useState } from 'react';
import { apiRequest } from '../apiClient';
import { buildUiHelpers } from './sharedUi';

export default function AccountDataRequest({ COLORS }) {
  const { Btn } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  const [busy, setBusy] = useState(false);
  const [ticketId, setTicketId] = useState(null);
  const [error, setError] = useState('');

  async function requestExport() {
    setBusy(true);
    setError('');
    try {
      const data = await apiRequest('/me/data-export-request', { method: 'POST' });
      setTicketId(data.ticket_id);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return <div style={{ marginBottom: 16 }}>
    <Btn type="button" color="ghost" onClick={requestExport} disabled={busy || Boolean(ticketId)}>
      {busy ? 'Ticket wird erstellt...' : 'Persönliche Daten per Ticket anfordern'}
    </Btn>
    {ticketId && <p role="status" style={{ color: COLORS.green }}>Deine Anfrage wird unter Ticket #{ticketId} bearbeitet. Ein Admin erstellt den Export und stellt ihn dir zur Verfügung.</p>}
    {error && <p role="alert" style={{ color: COLORS.red }}>{error}</p>}
  </div>;
}
